import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  searchTerm: '',

  filters: {
    department_ids: [],
    office_ids: [],
    employment_type: [],
  },

  sort: {
    element: 'created_at',
    order: 'desc',
    label: 'Created date (newest to oldest)',
    value: 'desc',
  },
};

const { reducer, actions: scoreCardAction } = createSlice({
  name: 'scoreCard',
  initialState,

  reducers: {
    applyFilter: (state, { payload: { key, value } }) => {
      state.filters[key] = value;
    },

    applySort: (state, { payload: { element, order } }) => {
      state.sort.element = element;
      state.sort.order = order;
    },

    applySearchTerm: (state, { payload }) => {
      state.searchTerm = payload?.searchTerm;
    },

    clearFilter: (state, { payload }) => {
      const { key, isMulti = false } = payload;
      state.filters[key] = isMulti ? [] : null;
    },

    applySearch: (state, { payload }) => {
      state.searchTerm = payload?.searchTerm;
      state.page = { ...initialState.page };
    },

    clearAllFilter: (state) => {
      state.page = { ...initialState.page };
      state.filters = { ...initialState.filters };
    },
  },
});

export { scoreCardAction };
export const {
  applyFilter,
  applySort,
  applySearchTerm,
  applySearch,
  clearFilter,
  clearAllFilter,
} = scoreCardAction;
export default reducer;
